import { Star, Clock, IndianRupee } from "lucide-react";

export default function RestaurantCard({ r, idx = 0 }) {
  return (
    <article
      data-testid={`restaurant-card-${r.id}`}
      className="group bg-white border border-neutral-200 rounded-2xl overflow-hidden hover:-translate-y-1 hover:shadow-xl hover:border-[#84CC16] transition-all"
    >
      <div className="relative aspect-[16/10] overflow-hidden bg-neutral-100">
        <img
          src={r.image}
          alt={r.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        {r.tags?.[0] && (
          <span className="absolute top-3 left-3 bg-black text-white text-[10px] uppercase tracking-[0.2em] px-2.5 py-1 rounded-full">
            {r.tags[0]}
          </span>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-display font-bold text-lg text-ink-900 leading-tight">{r.name}</h3>
          <div className="flex items-center gap-1 bg-[#65A30D] text-white text-xs font-bold rounded-md px-2 py-1 shrink-0">
            <Star size={12} fill="white" /> {Number(r.rating ?? 0).toFixed(1)}
          </div>
        </div>
        <p className="text-sm text-neutral-600 mt-1 truncate">{r.cuisine}</p>
        <div className="border-t border-dashed border-neutral-200 mt-4 pt-3 flex items-center justify-between text-xs text-neutral-700">
          <span className="inline-flex items-center gap-1"><Clock size={13} /> {r.eta_min} min</span>
          <span className="inline-flex items-center gap-0.5"><IndianRupee size={12} />{r.price_for_two} for two</span>
        </div>
        <div className="mt-1 text-[11px] text-neutral-500">{r.location}</div>
      </div>
    </article>
  );
}
